import React from 'react'
import styled from 'styled-components'

import Image from '../../atoms/Image'

import { MysqlRanksEdge, MysqlSurveyQuestionsEdge } from '../../graphqlTypes'

const Container = styled.ul`
  display: flex;
  flex-wrap: wrap;
  list-style: none;
`

const ListItem = styled.li`
  border: 1px solid ${({ theme }) => theme.palette.border.light};
  border-radius: 3px;
  box-sizing: border-box;
  margin: 5px 5px 0 0;
  padding: 6px 10px;
  &:last-child {
    margin-right: 0;
  }
`

const Text = styled.span`
  color: ${({ theme }) => theme.palette.font.main};
  font-size: 12px;
  font-weight: bold;
  vertical-align: middle;
`

const Icon = styled(Image)`
  display: inline-block;
  margin: 0 0 0 5px;
  vertical-align: middle;
  width: 24px;
  height: 24px;
`

type Props = {
  rank: MysqlRanksEdge | undefined
  surveyQuestions: MysqlSurveyQuestionsEdge[]
}

export default function ItemizedReviewList({ rank, surveyQuestions }: Props) {
  // survey_question_idから質問の内容を引けるようにする
  const surveyQuestionContents = surveyQuestions.reduce<{ [key: number]: string }>(
    (result, { node }) => ({ ...result, [node.mysqlId!]: node.content! }),
    {}
  )

  return (
    <Container>
      {JSON.parse(rank!.node.ratings!).map((rating: { survey_question_id: number; value: number }) => (
        <ListItem key={rating.survey_question_id}>
          <Text>{surveyQuestionContents[rating.survey_question_id]}</Text>
          <Icon
            alt={`「${surveyQuestionContents[rating.survey_question_id]}」の評価`}
            filename={(() => {
              if (rating.value >= 4) return 'icon-circle-flower.png'
              if (rating.value >= 3) return 'icon-circle-double.png'
              return 'icon-circle-single.png'
            })()}
          />
        </ListItem>
      ))}
    </Container>
  )
}
